import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-600);
`

export const Description = styled.p`
  color: var(--text-secondary);
  margin: 0;
  font-size: var(--font-size-300);
`

export const UrisContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
`

export const UriItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-300);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-brand);
  background: var(--bg-secondary);
  user-select: none;
`

export const UriContent = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-300);
  flex: 1;
  min-width: 0;
`

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  cursor: grab;
  color: var(--icon-secondary);

  &:active {
    cursor: grabbing;
  }
`

export const UriText = styled.span`
  color: var(--text-primary);
  font-family: monospace;
  font-size: var(--font-size-300);
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const DefaultBadge = styled.span`
  background: var(--bg-brand);
  color: var(--text-on-brand);
  padding: var(--space-50) var(--space-200);
  border-radius: var(--radius-brand);
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-medium);
  text-transform: uppercase;
  letter-spacing: var(--font-letter-spacing-densest);
  margin-right: var(--space-300);
`

export const AddUriContainer = styled.div`
  display: flex;
  gap: var(--space-300);
  align-items: flex-end;
  width: 100%;

  & > div {
    flex: 1;
    min-width: 0;
  }

  & > button {
    white-space: nowrap;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const SectionLabel = styled.label`
  font-size: var(--font-size-400);
  color: var(--text-primary);
  display: block;
  border-bottom: 1px solid var(--border-secondary);
`

export const CredentialsSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: var(--space-400);
`
